import { To } from 'react-router-dom';
import { StyledNavLink } from './LinkStyles';
import { GetProps } from 'antd';

export type TLinkPath = To;

export type TLinkChildren = string | JSX.Element;

export type ILinkProps = Omit<GetProps<typeof StyledNavLink>, 'to'> & {
  path: TLinkPath;
};

const Link = ({ path, ...props }: ILinkProps): JSX.Element => <StyledNavLink {...props} to={path} />;

export default Link;
